import { As2PartnerDirection } from '@core/models/as2-message.model';

export function directionLabel(direction?: string): string {
    return (direction || 'BIDIRECTIONAL').toUpperCase();
}

export function directionBadgeClass(direction?: string): string {
    const d = directionLabel(direction);
    if (d === 'SEND') return 'bg-blue-100 text-blue-800';
    if (d === 'RECEIVE') return 'bg-green-100 text-green-800';
    if (d === 'BIDIRECTIONAL') return 'bg-purple-100 text-purple-800';
    return 'bg-slate-100 text-slate-600';
}

export function canSendAs2Partner(direction?: string): boolean {
    const d = directionLabel(direction);
    return d === 'SEND' || d === 'BIDIRECTIONAL';
}

export function canReceiveAs2Partner(direction?: string): boolean {
    const d = directionLabel(direction);
    return d === 'RECEIVE' || d === 'BIDIRECTIONAL';
}

export function sanitizePartnerToken(name: string): string {
    return name.replace(/[^A-Za-z0-9]/g, '');
}

export function defaultRouteNames(partnerName: string): {
    testOutbound: string;
    testInbound: string;
    prodOutbound: string;
    prodInbound: string;
} {
    const token = sanitizePartnerToken(partnerName) || 'Partner';
    return {
        testOutbound: `Antar-to-${token}-Test`,
        testInbound: `${token}-Test-to-Antar`,
        prodOutbound: `Antar-to-${token}`,
        prodInbound: `${token}-to-Antar`,
    };
}

export type As2DirectionChoice = As2PartnerDirection;
